import * as z from "zod";

export const externalReturnProvider = ["loop", "returnlogic"] as const;
export type ExternalReturnProvider = (typeof externalReturnProvider)[number];

const StartExternalProviderImportInputSchema_ = z.object({
  teamId: z.string(),
  provider: z.enum(externalReturnProvider),
  // How far back to sync (the "sync since" date)
  stopAt: z.iso.datetime(),
});

export const StartExternalProviderImportInputSchema: z.ZodType<StartExternalProviderImportInput> =
  StartExternalProviderImportInputSchema_;
export interface StartExternalProviderImportInput
  extends z.infer<typeof StartExternalProviderImportInputSchema_> {}

export const startExternalProviderImport = {
  name: "startExternalProviderImport" as const,
  input: StartExternalProviderImportInputSchema,
  output: z.object({ workflowId: z.string() }),
};
